import React from 'react';
import Dendrograph from '../../visualization/Dendrograph';

const DendrographView = () => {
  return (
    <div className="h-full">
      <Dendrograph />
    </div>
  );
};

export default DendrographView;